module.exports = __webpack_public_path__ + "img/pigai-iocn-03.db54eaf8.png";